import React, { useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";

import { makeStyles } from '@material-ui/core/styles';

import Chip from '@material-ui/core/Chip';

import FileCopy from '@material-ui/icons/FileCopyTwoTone';
import DoneIcon from '@material-ui/icons/Done';
import AddIcon from '@material-ui/icons/Add';
import RoominvitationService from "../../../../services/RoominvitationService";
import {selectChannelId} from "../../../../store/reducers/appSlice";
import {unsetChannelInvitationUid, setChannelInvitationUid} from "../../../../store/reducers/appSlice";


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
}));


const CampaignInviteModalContent = (props) => {

  const dispatch = useDispatch();
  const activeCampaign = useSelector(selectChannelId)
  const { invite } = props;
  const [copiedState, setCopiedState] = useState(false);
  const [inviteUrl, setInviteUrl] = useState(null);


  let chipContent = inviteUrl !== null ? inviteUrl : 'Create invitation url'

  useEffect(() => {
    setInviteUrl(invite !== null
      ? window.location.protocol + "//" + window.location.host + "/invite/" + invite
      : null)
  }, [invite]);

  const classes = useStyles();

  const deleteRoomInvitation = () => {
    (new RoominvitationService()).revokeInvitationsForChannel(activeCampaign).then(function(){
      dispatch(unsetChannelInvitationUid())
    });
  }

  const createNewRoomInvitation = () => {
    (new RoominvitationService()).createNewInvitationForRoomId(activeCampaign).then(function(uid){
      console.log(uid)
      dispatch(setChannelInvitationUid(
        {
          channelInvitationUid: uid
        }
      ))
    });
  }

  const handleClick = () => {

    if (invite !== null) {
      console.log('clicked')
      navigator.clipboard.writeText(inviteUrl).then(function() {
        setCopiedState(true)
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });

    } else {
      setCopiedState(false)
      createNewRoomInvitation()
    }
  };


  const chip = <div className={classes.root}><Chip
    icon={inviteUrl !== null ? (!copiedState ? <FileCopy /> : <DoneIcon />) : <AddIcon />}
    label={chipContent}
    clickable
    color="light"
    onClick={handleClick}
    onDelete={inviteUrl !== null ? deleteRoomInvitation : ''} // By setting this to empty string, the chip's delete button won't render
    // deleteIcon={<DoneIcon />}
  /></div>



  return ( chip );

};
export default CampaignInviteModalContent;